import { render, staticRenderFns } from "./common-searchType.vue?vue&type=template&id=28558b56&"
import script from "./common-searchType.vue?vue&type=script&lang=js&"
export * from "./common-searchType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports